var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/utils/init-masonry.tsx
import React17 from "react";

// src/components/masonry-provider/masonry-provider.component.tsx
import React16, { useState as useState2 } from "react";
import { ObservabilityErrorBoundary as ObservabilityErrorBoundary3 } from "@leagueplatform/observability";
import { getObservabilityContext as getObservabilityContext6 } from "@leagueplatform/masonry-api";

// src/utils/log-error.ts
var MasonryLogPreffix = "[Masonry]:";
var getStylingFromString = (msg) => {
  var _a;
  const styleLength = (_a = msg.match(/%c/g)) == null ? void 0 : _a.length;
  return [...Array(styleLength)].map(
    (_, i) => `font-weight: ${i % 2 === 0 ? "bold" : "medium"}`
  );
};
var logError = (msg) => {
  if (true) {
    console.error(`${MasonryLogPreffix} ${msg}`, ...getStylingFromString(msg));
  }
};
var logWarning = (msg) => {
  if (true) {
    console.warn(`${MasonryLogPreffix} ${msg}`, ...getStylingFromString(msg));
  }
};

// src/components/widgets-wrapper/widgets-wrapper.component.tsx
import React15 from "react";
import { StackLayout as StackLayout2 } from "@leagueplatform/genesis-core";
import { ErrorPage, ERROR_TYPES } from "@leagueplatform/masonry-widgets";
import {
  useGetWidgetContainer
} from "@leagueplatform/masonry-api";

// src/components/spinner/spinner.component.tsx
import * as React2 from "react";
import { Spinner, StackLayout } from "@leagueplatform/genesis-core";

// src/hooks/use-get-config.hook.ts
import { useContext } from "react";

// src/context/masonry-config-context.tsx
import React from "react";

// src/constants/supported-api-version.ts
var MINIMUM_API_VERSION = 0;
var MAXIMUM_API_VERSION = 2;

// src/context/masonry-config-context.tsx
var defaultConfig = {
  appId: "",
  apiVersion: MINIMUM_API_VERSION,
  analytics: {
    screenName: "",
    productArea: ""
  },
  uiConfig: {
    spinnerConfig: {
      thickness: 1.5,
      size: "48px",
      tint: "$interactiveActionPrimary",
      containerHeight: "80vh"
    }
  }
};
var MasonryConfigContext = React.createContext(defaultConfig);

// src/hooks/use-get-config.hook.ts
var useGetConfig = () => {
  const config = useContext(MasonryConfigContext);
  return config;
};

// src/components/spinner/spinner.component.tsx
var MasonrySpinner = () => {
  const { uiConfig } = useGetConfig();
  const {
    spinnerConfig: { tint, size, thickness, containerHeight } = {},
    CustomLoader
  } = uiConfig;
  return /* @__PURE__ */ React2.createElement(
    StackLayout,
    {
      horizontalAlignment: "center",
      verticalAlignment: "center",
      css: { height: "100%", minHeight: containerHeight }
    },
    CustomLoader ? /* @__PURE__ */ React2.createElement(CustomLoader, null) : /* @__PURE__ */ React2.createElement(Spinner, { loading: true, tint, size, thickness })
  );
};

// src/components/widget-wrapper/widget-wrapper.component.tsx
import React10 from "react";
import { SkeletonBox } from "@leagueplatform/web-common-components";
import {
  getObservabilityContext as getObservabilityContext3,
  useGetWidgetData
} from "@leagueplatform/masonry-api";
import { ObservabilityErrorBoundary } from "@leagueplatform/observability";

// src/components/custom-widget/custom-widget.component.tsx
import React3 from "react";

// src/hooks/use-get-custom-widget-module-from-config.hook.ts
import { useMemo } from "react";

// src/utils/custom-module-utils.tsx
import {
  LargeVisualCardWidget,
  XSVisualCardWidget,
  TextAndCTACardWidget,
  SmallVisualCardWidget,
  NotificationBannerWidget,
  NotificationCardWidget,
  WelcomeBanner,
  SectionHeader,
  CarouselWidget,
  ProgressRingCardWidget,
  ProgressBarCardWidget,
  TwoUpCardWidget,
  HeroBanner,
  ImageFooter,
  MetricCardWidget
} from "@leagueplatform/masonry-widgets";
import {
  WidgetType,
  getObservabilityContext
} from "@leagueplatform/masonry-api";
import { captureError } from "@leagueplatform/observability";
var captureMasonryError = (errorMessage, context = {}, errorName) => captureError(
  new Error(errorMessage),
  getObservabilityContext(__spreadProps(__spreadValues({}, context), {
    errorName: errorName || "Masonry - Error"
  }))
);
var hasCustomModuleKey = (moduleKey, customWidgetModules = []) => customWidgetModules.some((module) => module.moduleKey === moduleKey);
var getCustomModuleByKey = (moduleKey, customWidgetModules = []) => customWidgetModules.find((module) => module.moduleKey === moduleKey);
var getCustomWidgetModule = (moduleKey, customWidgetModules, appId) => {
  if (moduleKey === "default")
    return null;
  if (!customWidgetModules || !hasCustomModuleKey(moduleKey, customWidgetModules)) {
    logError(
      `No custom module with %c moduleKey '${moduleKey}' %cprovided to Masonry config. Please check your config!!`
    );
    captureMasonryError(
      `No customWidgetModule with moduleKey ${moduleKey} provided to Masonry config.`,
      {
        tags: {
          container: appId,
          moduleKey
        }
      }
    );
    return null;
  }
  const widgetModule = getCustomModuleByKey(moduleKey, customWidgetModules);
  return widgetModule;
};
var WidgetTypeToSimpleComponentMap = {
  [WidgetType.TEXT_WITH_CTA_CARD]: TextAndCTACardWidget,
  [WidgetType.LARGE_VISUAL_CARD]: LargeVisualCardWidget,
  [WidgetType.SMALL_VISUAL_CARD]: SmallVisualCardWidget,
  [WidgetType.CAROUSEL]: CarouselWidget,
  [WidgetType.WELCOME_BANNER]: WelcomeBanner,
  [WidgetType.HERO_BANNER]: HeroBanner,
  [WidgetType.XS_VISUAL_CARD]: XSVisualCardWidget,
  [WidgetType.NOTIFICATION_BANNER]: NotificationBannerWidget,
  [WidgetType.NOTIFICATION_CARD]: NotificationCardWidget,
  [WidgetType.SECTION_HEADER]: SectionHeader,
  [WidgetType.PROGRESS_RING]: ProgressRingCardWidget,
  [WidgetType.PROGRESS_BAR]: ProgressBarCardWidget,
  [WidgetType.TWO_UP_CARD]: TwoUpCardWidget,
  [WidgetType.IMAGE_FOOTER]: ImageFooter,
  [WidgetType.METRIC_CARD]: MetricCardWidget
};
var ProviderNameByWidgetType = {
  [WidgetType.TEXT_WITH_CTA_CARD]: "useTextWithCTACardWidgetData",
  [WidgetType.LARGE_VISUAL_CARD]: "useLargeVisualCardWidgetData",
  [WidgetType.SMALL_VISUAL_CARD]: "useSmallVisualCardWidgetData",
  [WidgetType.CAROUSEL]: "useCarouselWidgetData",
  [WidgetType.HERO_BANNER]: "useHeroBannerWidgetData",
  [WidgetType.WELCOME_BANNER]: "useWelcomeBannerWidgetData",
  // Deprecate - v2
  [WidgetType.XS_VISUAL_CARD]: "useXSVisualCardWidgetData",
  [WidgetType.NOTIFICATION_BANNER]: "useNotificationBannerWidgetData",
  [WidgetType.PROGRESS_RING]: "useProgressRingCardWidgetData",
  [WidgetType.PROGRESS_BAR]: "useProgressBarCardWidgetData",
  [WidgetType.TWO_UP_CARD]: "useTwoUpCardWidgetData",
  [WidgetType.IMAGE_FOOTER]: "useImageFooterWidgetData"
};
var getProviderFromWidgetType = (widgetData, customWidgetModule, widgetModule, appId) => {
  var _a;
  const providerName = ProviderNameByWidgetType[widgetData.type];
  const provider = (_a = customWidgetModule == null ? void 0 : customWidgetModule.customWidgetDataHooks) == null ? void 0 : _a[providerName];
  if (!provider) {
    logError(
      `Provider %c${providerName}%c for widget type - ${widgetData.type} is not provided to customWidgetModule with %c moduleKey - ${widgetModule}%c. Please check your config!!`
    );
    captureMasonryError(
      `Provider ${providerName} is not provided to customWidgetModule.`,
      {
        tags: {
          container: appId,
          widgetType: widgetData.type,
          moduleKey: widgetModule,
          widgetId: widgetData.id
        }
      }
    );
    return null;
  }
  return provider;
};
var getCustomWidgetComponent = (customWidgetModule, widgetId, appId, customType) => {
  var _a;
  if (!customType) {
    logError(
      `No %c'custom_type'%c key found for widget id ${widgetId} in widget data coming from %c'get_widget_container'%c API. Please check your Masonry container in BE.`
    );
    captureMasonryError(
      `No 'custom_type' key found for widget id ${widgetId} in widget data coming from 'get_widget_container' API`,
      {
        tags: {
          widgetId,
          container: appId
        }
      }
    );
    return null;
  }
  if (!((_a = customWidgetModule == null ? void 0 : customWidgetModule.customWidgetsUI) == null ? void 0 : _a.length)) {
    logError(
      `No 'customWidgetsUI[]' is provided in Masonry config. Please check your config!`
    );
    captureMasonryError(
      `No 'customWidgetsUI[]' is provided for moduleKey: ${customWidgetModule.moduleKey} in Masonry config`,
      {
        tags: {
          widgetId,
          container: appId,
          moduleKey: customWidgetModule.moduleKey
        }
      }
    );
    return null;
  }
  const customWidget = customWidgetModule.customWidgetsUI.find(
    ({ type: componentType }) => componentType === customType
  );
  if (!customWidget) {
    logError(
      `No custom widget with type %c${customType} %cis provided inside %c'customWidgetsUI[]'%c for moduleKey ${customWidgetModule.moduleKey}. Please check your config!`
    );
    captureMasonryError(
      `No custom widget with type ${customType} found in Masonry Config.`,
      {
        tags: {
          widgetId,
          container: appId,
          moduleKey: customWidgetModule.moduleKey
        }
      }
    );
    return null;
  }
  return customWidget.widget;
};

// src/hooks/use-get-custom-widget-module-from-config.hook.ts
var useGetCustomWidgetModuleFromConfig = ({
  moduleKey
}) => {
  const config = useGetConfig();
  const moduleProvider = useMemo(
    () => getCustomWidgetModule(
      moduleKey,
      config == null ? void 0 : config.customWidgetModules,
      config == null ? void 0 : config.appId
    ),
    [moduleKey, config == null ? void 0 : config.customWidgetModules, config == null ? void 0 : config.appId]
  );
  return moduleProvider;
};

// src/components/custom-widget/custom-widget.component.tsx
var CustomWidget = ({ widget }) => {
  const config = useGetConfig();
  const moduleProvider = useGetCustomWidgetModuleFromConfig({
    moduleKey: widget.module
  });
  const CustomWidgetComponent = getCustomWidgetComponent(
    moduleProvider,
    widget.id,
    config == null ? void 0 : config.appId,
    widget.custom_type
  );
  if (!CustomWidgetComponent)
    return null;
  return /* @__PURE__ */ React3.createElement(CustomWidgetComponent, { widget });
};

// src/components/widget-provider-from-type/widget-provider-from-widget-type.component.tsx
import React9 from "react";
import { getObservabilityContext as getObservabilityContext2 } from "@leagueplatform/masonry-api";
import { captureMessage } from "@leagueplatform/observability";

// src/components/default-widget/default-widget.tsx
import React4, { useCallback, useMemo as useMemo2, useState } from "react";
import { usePostDismissWidget } from "@leagueplatform/masonry-api";

// src/hooks/use-get-traits-for-media.hook.ts
import { queryHelpers, useMediaQuery } from "@leagueplatform/genesis-core";
var useGetTraitsForMedia = (traits) => {
  const isMobile = useMediaQuery(queryHelpers.down("mobileLandscape"));
  const isTablet = useMediaQuery(
    queryHelpers.between(["mobileLandscape", "laptop"])
  );
  const isLaptop = useMediaQuery(queryHelpers.only("laptop"));
  const isDesktop = useMediaQuery(queryHelpers.up("desktop"));
  if (isMobile)
    return traits == null ? void 0 : traits.mobile;
  if (isTablet)
    return traits == null ? void 0 : traits.tablet;
  if (isLaptop)
    return traits == null ? void 0 : traits.laptop;
  if (isDesktop)
    return traits == null ? void 0 : traits.desktop;
  return {};
};

// src/utils/widget-data-mapping.ts
var convertToCamelCase = (str) => str.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
var createObjectMapping = (obj) => Object.keys(obj).reduce((finalObj, key) => {
  finalObj[convertToCamelCase(key)] = obj[key];
  return finalObj;
}, {});
var mapXSVisualCardData = (params) => createObjectMapping(params);
var mapNotificationBannerData = (params) => createObjectMapping(params);
var mapLargeAndSmallVisualCardData = (params) => createObjectMapping(params);
var mapTextWithCTACardData = (params) => createObjectMapping(params);
var mapCarousalData = (params) => __spreadProps(__spreadValues({}, createObjectMapping(params)), {
  items: params.items.map((cardItem) => createObjectMapping(cardItem))
});
var mapTwoUpCardData = (params) => __spreadProps(__spreadValues({}, createObjectMapping(params)), {
  items: params.items.map((cardItem) => createObjectMapping(cardItem))
});
var mapProgressBarCardData = (params) => createObjectMapping(params);
var mapProgressRingCardData = (params) => createObjectMapping(params);
var mapWidgetDataFromAPI = (data, widgetType) => {
  switch (widgetType) {
    case "text_with_button":
      return mapTextWithCTACardData(data);
    case "text_with_large_image":
      return mapLargeAndSmallVisualCardData(data);
    case "text_with_small_image":
      return mapLargeAndSmallVisualCardData(data);
    case "carousel":
      return mapCarousalData(data);
    case "notification_banner":
      return mapNotificationBannerData(data);
    case "xs_visual_card":
      return mapXSVisualCardData(data);
    case "2_up_card":
      return mapTwoUpCardData(data);
    case "progress_bar":
      return mapProgressBarCardData(data);
    case "progress_ring":
      return mapProgressRingCardData(data);
    default:
      return createObjectMapping(data);
  }
};

// src/utils/merge-default-and-custom-widget-data.ts
var mergeDefaultAndCustomWidgetData = (defaultData, customWidgetData) => __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, (customWidgetData == null ? void 0 : customWidgetData.displayData) || {}), (customWidgetData == null ? void 0 : customWidgetData.widgetSettings) || {}), mapWidgetDataFromAPI((defaultData == null ? void 0 : defaultData.attributes) || {}, defaultData.type) || {}), {
  traits: defaultData == null ? void 0 : defaultData.traits
});

// src/utils/widget-analytics-events.ts
import { trackAnalyticsEvent, EVENT_NAME } from "@leagueplatform/analytics";
import { WidgetType as WidgetType2 } from "@leagueplatform/masonry-api";

// src/constants/analytics-event-detail-mapping.ts
var DetailLargeVisualCardButtonClick = "text_with_large_image";
var DetailSmallVisualCardButtonClick = "text_with_small_image";
var DetailXSVisualCardButtonClick = "text_with_xsmall_image";
var DetailNotificationBannerButtonClick = "notification_banner";
var DetailNotificationCardButtonClick = "notification_card";
var DetailProgressRingButtonClick = "progress_ring";
var DetailProgressBarButtonClick = "progress_bar";
var DetailHeroBannerButtonClick = "welcome_banner_primary_button";
var DetailTextWithCTAButtonClick = "text_with_button_primary_button";
var Detail2UpCardWithCTAButtonClick = "2_up_card";
var DetailMetricCardButtonClick = "metric_card";
var DetailCarouselScrollRight = "scroll carousel right";
var DetailCarouselScrollLeft = "scroll carousel left";
var DetailCarouselHeaderButtonClick = "carousel_header_button";
var DetailCarouselHeaderSelectItem = "select item from carousel";
var DetailStackSelectItem = "select item from stack";

// src/utils/widget-analytics-events.ts
var getDataForAnalyticsByWidgetType = (type, widgetAttributesAndTraits) => {
  switch (type) {
    case WidgetType2.XS_VISUAL_CARD:
      return {
        text_detail: widgetAttributesAndTraits.heading,
        text_sub_detail: widgetAttributesAndTraits.body,
        link_url: widgetAttributesAndTraits.linkUrl
      };
    case WidgetType2.PROGRESS_BAR:
      return {
        text_detail: widgetAttributesAndTraits.eyebrow,
        current_progress: widgetAttributesAndTraits.currentText,
        maximum_progress: widgetAttributesAndTraits.suffixText,
        remaining_progress: widgetAttributesAndTraits.footerText,
        progress_percent: widgetAttributesAndTraits.progress,
        link_url: widgetAttributesAndTraits.action
      };
    case WidgetType2.PROGRESS_RING:
      return {
        text_detail: widgetAttributesAndTraits.eyebrow,
        current_progress: widgetAttributesAndTraits.currentText,
        maximum_progress: widgetAttributesAndTraits.suffixText,
        progress_percent: widgetAttributesAndTraits.progress,
        link_url: widgetAttributesAndTraits.action
      };
    case WidgetType2.HERO_BANNER:
      return {
        text_detail: widgetAttributesAndTraits.buttonLabel,
        link_url: widgetAttributesAndTraits.buttonAction
      };
    case WidgetType2.NOTIFICATION_CARD:
      return {
        text_detail: widgetAttributesAndTraits.heading,
        text_sub_detail: widgetAttributesAndTraits.subheading,
        link_url: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.url
      };
    case WidgetType2.METRIC_CARD:
      return {
        text_detail: widgetAttributesAndTraits.heading
      };
    default:
      return {
        text_detail: widgetAttributesAndTraits.title,
        text_sub_detail: widgetAttributesAndTraits.description,
        link_url: widgetAttributesAndTraits.linkUrl
      };
  }
};
var widgetAnalyticsEvents = (config, widgetType, widgetAttributesAndTraits, productIdentifier) => {
  const trackMasonryAnalytics = (event, widgetProperties) => () => {
    var _a, _b;
    return trackAnalyticsEvent(event, __spreadValues({
      product_area: (_a = config == null ? void 0 : config.analytics) == null ? void 0 : _a.productArea,
      sub_product_area: config == null ? void 0 : config.appId,
      screen_name: (_b = config == null ? void 0 : config.analytics) == null ? void 0 : _b.screenName,
      product_identifier: productIdentifier
    }, widgetProperties));
  };
  const getCarouselAnalyticEvents = () => {
    var _a, _b;
    const carouselRollup = {
      carousel_array: (_a = widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.items) == null ? void 0 : _a.map(
        (carouselItem) => carouselItem.title
      ),
      carousel_name: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.title,
      carousel_num_resources: (_b = widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.items) == null ? void 0 : _b.length
    };
    return {
      onScrollLeft: trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselScrollLeft
      }, carouselRollup)),
      onScrollRight: trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselScrollRight
      }, carouselRollup)),
      onSelectItem: (item, index) => trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselHeaderSelectItem,
        sub_detail: item.title,
        text_detail: item.overline,
        carousel_index: index,
        link_url: item.linkUrl
      }, carouselRollup))(),
      onSelectHeader: trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselHeaderButtonClick,
        sub_detail: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.headerLinkHint,
        link_url: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.headerLinkUrl
      }, carouselRollup))
    };
  };
  const getTwoUpCardAnalyticsEvent = () => ({
    onItemClick: ({ heading, body, actionLink }, index) => trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, {
      detail: Detail2UpCardWithCTAButtonClick,
      text_detail: heading,
      text_sub_detail: body,
      container_index: index,
      link_url: actionLink
    })()
  });
  const getNotificationBannerAnalyticsEvent = () => ({
    onCardClick: ({ heading, body, linkUrl }) => trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, {
      detail: DetailNotificationBannerButtonClick,
      text_detail: heading,
      text_sub_detail: body,
      link_url: linkUrl
    })()
    /* @TODO Add dismiss analytics here for notification banner */
  });
  const getStackAnalyticsEvents = () => {
    const stackRollup = {
      stack_array: widgetAttributesAndTraits.items.map(
        (stackItem) => {
          var _a, _b;
          return ((_a = stackItem == null ? void 0 : stackItem.attributes) == null ? void 0 : _a.title) || ((_b = stackItem == null ? void 0 : stackItem.attributes) == null ? void 0 : _b.heading);
        }
      ),
      stack_name: widgetAttributesAndTraits.heading,
      stack_num_resources: widgetAttributesAndTraits.items.length
    };
    return {
      onItemClick: ({ attributes, type }, index) => trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues(__spreadValues({
        detail: DetailStackSelectItem,
        stack_index: index,
        component_detail: type
      }, getDataForAnalyticsByWidgetType(
        type,
        attributes
      )), stackRollup))()
    };
  };
  const getGenericCarouselAnalyticsEvents = () => {
    const carouselRollup = {
      carousel_array: widgetAttributesAndTraits.items.map(
        (stackItem) => {
          var _a, _b;
          return ((_a = stackItem == null ? void 0 : stackItem.attributes) == null ? void 0 : _a.title) || ((_b = stackItem == null ? void 0 : stackItem.attributes) == null ? void 0 : _b.heading);
        }
      ),
      carousel_name: widgetAttributesAndTraits.heading,
      carousel_num_resources: widgetAttributesAndTraits.items.length
    };
    return {
      onScrollLeft: trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselScrollLeft
      }, carouselRollup)),
      onScrollRight: trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselScrollRight
      }, carouselRollup)),
      onItemClick: ({ attributes, type }, index) => trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues(__spreadValues({
        detail: DetailCarouselHeaderSelectItem,
        carousel_index: index,
        component_detail: type
      }, getDataForAnalyticsByWidgetType(
        type,
        attributes
      )), carouselRollup))(),
      onSelectHeader: trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselHeaderButtonClick,
        sub_detail: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.headerButtonLabel,
        link_url: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.headerButtonAction
      }, carouselRollup))
    };
  };
  const getCommonAnalyticsEvent = (widgetDetail) => () => ({
    onCardClick: trackMasonryAnalytics(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
      detail: widgetDetail
    }, getDataForAnalyticsByWidgetType(widgetType, widgetAttributesAndTraits)))
  });
  const getWidgetAnalyticsFromType = {
    /* ---- Complex Widgets ----*/
    [WidgetType2.CAROUSEL]: getCarouselAnalyticEvents,
    [WidgetType2.TWO_UP_CARD]: getTwoUpCardAnalyticsEvent,
    [WidgetType2.STACK]: getStackAnalyticsEvents,
    [WidgetType2.GENERIC_CAROUSEL]: getGenericCarouselAnalyticsEvents,
    /* ---- Simple Widgets ----*/
    [WidgetType2.HERO_BANNER]: getCommonAnalyticsEvent(
      DetailHeroBannerButtonClick
    ),
    [WidgetType2.PROGRESS_BAR]: getCommonAnalyticsEvent(
      DetailProgressBarButtonClick
    ),
    [WidgetType2.PROGRESS_RING]: getCommonAnalyticsEvent(
      DetailProgressRingButtonClick
    ),
    [WidgetType2.XS_VISUAL_CARD]: getCommonAnalyticsEvent(
      DetailXSVisualCardButtonClick
    ),
    [WidgetType2.NOTIFICATION_BANNER]: getNotificationBannerAnalyticsEvent,
    [WidgetType2.NOTIFICATION_CARD]: getCommonAnalyticsEvent(
      DetailNotificationCardButtonClick
    ),
    [WidgetType2.TEXT_WITH_CTA_CARD]: getCommonAnalyticsEvent(
      DetailTextWithCTAButtonClick
    ),
    [WidgetType2.LARGE_VISUAL_CARD]: getCommonAnalyticsEvent(
      DetailLargeVisualCardButtonClick
    ),
    [WidgetType2.SMALL_VISUAL_CARD]: getCommonAnalyticsEvent(
      DetailSmallVisualCardButtonClick
    ),
    [WidgetType2.METRIC_CARD]: getCommonAnalyticsEvent(
      DetailMetricCardButtonClick
    )
  };
  const widgetAnalyticsEventsFn = getWidgetAnalyticsFromType[widgetType];
  return widgetAnalyticsEventsFn ? widgetAnalyticsEventsFn() : {};
};

// src/components/default-widget/default-widget.tsx
var useGetDismissibleAction = (links, onDismissAnalytics) => {
  const [dismissed, setDismissed] = useState(false);
  const dismissibleLink = useMemo2(
    () => links == null ? void 0 : links.find((link) => link.rel === "dismiss"),
    [links]
  );
  const onDismiss = useCallback(() => {
    setDismissed(true);
    if (onDismissAnalytics)
      onDismissAnalytics();
  }, [setDismissed, onDismissAnalytics]);
  usePostDismissWidget(dismissed, dismissibleLink);
  return { dismissed, dismissible: !!dismissibleLink, onDismiss };
};
var DefaultWidget = ({
  data,
  config,
  component: WidgetComponent,
  isChildItem = false,
  onCardClick
}) => {
  const { type: widgetType, product_identifier: productIdentifier } = data;
  const traitsForMediaDevice = useGetTraitsForMedia(data.traits);
  const widgetAttributesAndTraits = mergeDefaultAndCustomWidgetData(data);
  const widgetAnalyticsProps = useMemo2(() => {
    if (!onCardClick) {
      return widgetAnalyticsEvents(
        config,
        widgetType,
        widgetAttributesAndTraits,
        productIdentifier
      );
    }
    return {};
  }, [
    onCardClick,
    config,
    widgetType,
    widgetAttributesAndTraits,
    productIdentifier
  ]);
  const { dismissed, dismissible, onDismiss } = useGetDismissibleAction(
    data.links,
    widgetAnalyticsProps == null ? void 0 : widgetAnalyticsProps.onDismiss
  );
  if (dismissed)
    return null;
  return /* @__PURE__ */ React4.createElement(
    WidgetComponent,
    __spreadProps(__spreadValues(__spreadValues(__spreadValues({
      onCardClick
    }, widgetAttributesAndTraits), traitsForMediaDevice), widgetAnalyticsProps), {
      onDismiss,
      dismissible,
      isChildItem,
      product_identifier: productIdentifier
    })
  );
};

// src/constants/widget-type-to-complex-component-map.ts
import { WidgetType as WidgetType5 } from "@leagueplatform/masonry-api";

// src/components/generic-carousel/generic-carousel.component.tsx
import * as React5 from "react";
import {
  GenericCarouselWidget,
  COMPLEX_WIDGET_CARDS_WIDTH
} from "@leagueplatform/masonry-widgets";
import { StackItem } from "@leagueplatform/genesis-core";
import { uniqueId } from "lodash";
var GenericCarousel = (_a) => {
  var _b = _a, {
    items,
    onItemClick
  } = _b, props = __objRest(_b, [
    "items",
    "onItemClick"
  ]);
  const config = useGetConfig();
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    /* @__PURE__ */ React5.createElement(GenericCarouselWidget, __spreadValues({}, props), items == null ? void 0 : items.map((item, index) => {
      const WidgetComponent = WidgetTypeToSimpleComponentMap[item.type];
      if (!WidgetComponent)
        return null;
      return /* @__PURE__ */ React5.createElement(
        StackItem,
        {
          css: { minWidth: COMPLEX_WIDGET_CARDS_WIDTH, height: "100%" }
        },
        /* @__PURE__ */ React5.createElement(
          DefaultWidget,
          {
            key: uniqueId(),
            data: item,
            component: WidgetComponent,
            config,
            onCardClick: () => onItemClick(item, index),
            isChildItem: true
          }
        )
      );
    }))
  );
};

// src/components/stack-widget/stack-widget.component.tsx
import * as React7 from "react";
import { StackWidgetWrapper } from "@leagueplatform/masonry-widgets";
import { WidgetType as WidgetType4 } from "@leagueplatform/masonry-api";

// src/components/stack-widget/stack-widget-items-list.component.tsx
import React6 from "react";
import { COMPLEX_WIDGET_CARDS_WIDTH as COMPLEX_WIDGET_CARDS_WIDTH2 } from "@leagueplatform/masonry-widgets";
import { StackItem as StackItem2 } from "@leagueplatform/genesis-core";
import { Orientation } from "@leagueplatform/masonry-api";
var StackItemsList = ({
  items,
  orientation,
  onItemClick
}) => {
  const config = useGetConfig();
  return /* @__PURE__ */ React6.createElement(React6.Fragment, null, items.map((item, index) => {
    const WidgetComponent = WidgetTypeToSimpleComponentMap[item.type];
    if (!WidgetComponent)
      return null;
    return /* @__PURE__ */ React6.createElement(
      StackItem2,
      {
        key: `${item.type}${index}`,
        css: { minWidth: COMPLEX_WIDGET_CARDS_WIDTH2 }
      },
      /* @__PURE__ */ React6.createElement(
        DefaultWidget,
        {
          data: item,
          component: WidgetComponent,
          config,
          isChildItem: orientation === Orientation.HORIZONTAL,
          onCardClick: () => onItemClick(item, index)
        }
      )
    );
  }));
};

// src/components/stack-widget/use-orientation-from-media-query.hook.ts
import { queryHelpers as queryHelpers2, useMediaQuery as useMediaQuery2 } from "@leagueplatform/genesis-core";
import { SupportedMedia as SupportedMedia2 } from "@leagueplatform/masonry-api";

// src/components/stack-widget/default-orientation-map.ts
import {
  WidgetType as WidgetType3,
  Orientation as Orientation2,
  SupportedMedia
} from "@leagueplatform/masonry-api";
var DefaultOrientationMap = {
  Default: Orientation2.VERTICAL,
  [WidgetType3.STACK]: {
    [SupportedMedia.MOBILE]: Orientation2.VERTICAL,
    [SupportedMedia.TABLET]: Orientation2.VERTICAL,
    [SupportedMedia.LAPTOP]: Orientation2.HORIZONTAL,
    [SupportedMedia.DESKTOP]: Orientation2.HORIZONTAL
  }
};

// src/components/stack-widget/use-orientation-from-media-query.hook.ts
var useOrientationFromMediaQuery = ({
  defaultOrientation,
  traits
}) => {
  var _a, _b, _c, _d;
  const isMobile = useMediaQuery2(queryHelpers2.down("mobileLandscape"));
  const isTablet = useMediaQuery2(queryHelpers2.only("tablet"));
  const isLaptop = useMediaQuery2(queryHelpers2.only("laptop"));
  const isDesktop = useMediaQuery2(queryHelpers2.up("desktop"));
  if (isMobile)
    return ((_a = traits == null ? void 0 : traits.mobile) == null ? void 0 : _a.orientation) || defaultOrientation[SupportedMedia2.MOBILE];
  if (isTablet)
    return ((_b = traits == null ? void 0 : traits.tablet) == null ? void 0 : _b.orientation) || defaultOrientation[SupportedMedia2.TABLET];
  if (isLaptop)
    return ((_c = traits == null ? void 0 : traits.laptop) == null ? void 0 : _c.orientation) || defaultOrientation[SupportedMedia2.LAPTOP];
  if (isDesktop)
    return ((_d = traits == null ? void 0 : traits.desktop) == null ? void 0 : _d.orientation) || defaultOrientation[SupportedMedia2.DESKTOP];
  return DefaultOrientationMap.Default;
};

// src/components/stack-widget/stack-widget.component.tsx
var StackWidget = ({
  heading,
  items,
  traits,
  onItemClick
}) => {
  const orientation = useOrientationFromMediaQuery({
    traits,
    defaultOrientation: DefaultOrientationMap[WidgetType4.STACK]
  });
  const traitItems = useGetTraitsForMedia(traits);
  return /* @__PURE__ */ React7.createElement(
    StackWidgetWrapper,
    {
      orientation,
      heading,
      gridColumnCount: traitItems == null ? void 0 : traitItems.gridColumnCount
    },
    /* @__PURE__ */ React7.createElement(
      StackItemsList,
      {
        onItemClick,
        items,
        orientation
      }
    )
  );
};

// src/constants/widget-type-to-complex-component-map.ts
var WidgetTypeToComplexComponentMap = __spreadProps(__spreadValues({}, WidgetTypeToSimpleComponentMap), {
  [WidgetType5.STACK]: StackWidget,
  [WidgetType5.GENERIC_CAROUSEL]: GenericCarousel
});

// src/components/widget-provider-from-type/widget-with-custom-module-provider.component.tsx
import React8 from "react";
var WidgetWithCustomModuleProvider = (_a) => {
  var _b = _a, {
    moduleProviderHook,
    widget,
    data,
    component: Component,
    config
  } = _b, props = __objRest(_b, [
    "moduleProviderHook",
    "widget",
    "data",
    "component",
    "config"
  ]);
  const { type: widgetType } = data;
  const customWidgetData = moduleProviderHook({ widget });
  const widgetAttributesAndTraits = mergeDefaultAndCustomWidgetData(
    data,
    customWidgetData
  );
  const widgetAnalyticsProps = widgetAnalyticsEvents(
    config,
    widgetType,
    widgetAttributesAndTraits,
    data == null ? void 0 : data.product_identifier
  );
  return /* @__PURE__ */ React8.createElement(
    Component,
    __spreadValues(__spreadValues(__spreadValues({}, widgetAttributesAndTraits), props), widgetAnalyticsProps)
  );
};

// src/components/widget-provider-from-type/widget-provider-from-widget-type.component.tsx
var WidgetProviderFromWidgetType = ({
  data,
  widget
}) => {
  const config = useGetConfig();
  const { type: widgetType } = data;
  const { module: moduleKey } = widget;
  const customWidgetModule = useGetCustomWidgetModuleFromConfig({
    moduleKey
  });
  const WidgetComponent = WidgetTypeToComplexComponentMap[widgetType];
  if (!WidgetComponent) {
    logWarning(
      `Unsupported widget type - %c${widgetType}%c found in container.`
    );
    captureMessage(
      `Unsupported widget type - ${widgetType} found in container.`,
      getObservabilityContext2({
        tags: {
          container: config.appId
        }
      })
    );
    return null;
  }
  if (widget.module !== "default") {
    const widgetProviderHook = getProviderFromWidgetType(
      data,
      customWidgetModule,
      widget.module,
      config.appId
    );
    if (widgetProviderHook) {
      return /* @__PURE__ */ React9.createElement(
        WidgetWithCustomModuleProvider,
        {
          moduleProviderHook: widgetProviderHook,
          data,
          widget,
          component: WidgetComponent,
          config
        }
      );
    }
    logWarning(
      `No custom widget provider found for widget type - %c${widgetType}%c and moduleKey - %c${widget.module}%c. Rendering widget with masonry data.`
    );
    captureMessage(
      `No custom widget provider found for widget type: ${widgetType}`,
      getObservabilityContext2({
        tags: {
          container: config.appId,
          widgetType,
          moduleKey: widget.module
        }
      })
    );
  }
  if (!data.attributes)
    return null;
  return /* @__PURE__ */ React9.createElement(DefaultWidget, { component: WidgetComponent, data, config });
};

// src/components/widget-wrapper/widget-wrapper.component.tsx
var MasonrySupportedWidget = ({ widget }) => {
  const { apiVersion } = useGetConfig();
  const {
    data: widgetData,
    isLoading,
    error
  } = useGetWidgetData(widget, apiVersion);
  if (isLoading)
    return /* @__PURE__ */ React10.createElement(SkeletonBox, { width: "100%", height: "120px" });
  if (error || !widgetData) {
    return null;
  }
  return /* @__PURE__ */ React10.createElement(WidgetProviderFromWidgetType, { data: widgetData, widget });
};
var WidgetWrapper = ({
  widget,
  appId
}) => (
  // Returning null as fallback component because masonry should not display anything if a widget fails to render
  /* @__PURE__ */ React10.createElement(
    ObservabilityErrorBoundary,
    {
      fallback: () => null,
      errorContext: getObservabilityContext3({
        tags: {
          errorName: `Masonry - Error while rendering widget: ${widget.id}`,
          container: appId,
          widgetId: widget.id,
          widgetType: widget.type
        }
      }),
      onError: (err) => {
        logError(
          `Masonry - Error while rendering widget: ${widget.id} ${err.message}`
        );
      }
    },
    widget.type === "custom_component" ? /* @__PURE__ */ React10.createElement(CustomWidget, { widget }) : /* @__PURE__ */ React10.createElement(MasonrySupportedWidget, { widget })
  )
);

// src/components/widget-wrapper/widget-wrapper-v2.component.tsx
import React14 from "react";
import {
  getObservabilityContext as getObservabilityContext5,
  useGetWidgetData as useGetWidgetData2
} from "@leagueplatform/masonry-api";
import { ObservabilityErrorBoundary as ObservabilityErrorBoundary2 } from "@leagueplatform/observability";

// src/components/spinner/masonry-skeleton.component.tsx
import React11 from "react";
import { useIntl } from "react-intl";
import { Box, VisuallyHidden } from "@leagueplatform/genesis-core";

// src/utils/skeleton-type-to-component-map.ts
import {
  ExtraSmallSkeleton,
  HeroBannerSkeleton,
  LargeSkeleton,
  SmallSkeleton
} from "@leagueplatform/masonry-widgets";
var SkeletonTypeToComponentMap = {
  loadingSmall: SmallSkeleton,
  loadingLarge: LargeSkeleton,
  loadingExtraSmall: ExtraSmallSkeleton,
  loadingHeroBanner: HeroBannerSkeleton
};

// src/components/spinner/masonry-skeleton.component.tsx
var MasonrySkeleton = ({
  loading
}) => {
  const { formatMessage } = useIntl();
  if (loading == null ? void 0 : loading.type) {
    const LoadingComponent = SkeletonTypeToComponentMap[loading == null ? void 0 : loading.type];
    if (LoadingComponent) {
      return /* @__PURE__ */ React11.createElement(Box, { "aria-busy": true, "aria-live": "polite" }, /* @__PURE__ */ React11.createElement(VisuallyHidden, null, formatMessage({ id: "LOADING" })), /* @__PURE__ */ React11.createElement(LoadingComponent, null));
    }
  }
  return null;
};

// src/components/widget-provider-from-type/widget-provider-from-widget-type-v2.component.tsx
import React13 from "react";
import {
  getObservabilityContext as getObservabilityContext4
} from "@leagueplatform/masonry-api";
import { captureMessage as captureMessage2 } from "@leagueplatform/observability";

// src/components/custom-widget/custom-widget-with-widget-data.component.tsx
import React12 from "react";
var CustomWidgetWithWidgetData = ({
  data
}) => {
  const config = useGetConfig();
  const moduleProvider = useGetCustomWidgetModuleFromConfig({
    moduleKey: data.module
  });
  const CustomWidgetComponent = getCustomWidgetComponent(
    moduleProvider,
    data.id,
    config == null ? void 0 : config.appId,
    data.type
  );
  if (!CustomWidgetComponent)
    return null;
  return /* @__PURE__ */ React12.createElement(CustomWidgetComponent, { widget: data });
};

// src/components/widget-provider-from-type/widget-provider-from-widget-type-v2.component.tsx
var WidgetProviderFromWidgetTypeV2 = ({
  data
}) => {
  const config = useGetConfig();
  const { type: widgetType, module } = data;
  if (widgetType && module)
    return /* @__PURE__ */ React13.createElement(
      CustomWidgetWithWidgetData,
      {
        data
      }
    );
  const WidgetComponent = WidgetTypeToComplexComponentMap[widgetType];
  if (!WidgetComponent) {
    logWarning(
      `Unsupported widget type - %c${widgetType}%c found in container.`
    );
    captureMessage2(
      `Unsupported widget type - ${widgetType} found in container.`,
      getObservabilityContext4({
        tags: {
          container: config.appId
        }
      })
    );
    return null;
  }
  if (!data.attributes)
    return null;
  return /* @__PURE__ */ React13.createElement(DefaultWidget, { component: WidgetComponent, data, config });
};

// src/components/widget-wrapper/widget-wrapper-v2.component.tsx
var MasonrySupportedWidget2 = ({ widget }) => {
  const { apiVersion } = useGetConfig();
  const { loading } = widget;
  const {
    data: widgetData,
    isLoading,
    error
  } = useGetWidgetData2(widget, apiVersion);
  if (isLoading) {
    return /* @__PURE__ */ React14.createElement(MasonrySkeleton, { loading });
  }
  if (error || !widgetData) {
    return null;
  }
  return /* @__PURE__ */ React14.createElement(WidgetProviderFromWidgetTypeV2, { data: widgetData });
};
var WidgetWrapperV2 = ({
  widget,
  appId
}) => (
  // Returning null as fallback component because masonry should not display anything if a widget fails to render
  /* @__PURE__ */ React14.createElement(
    ObservabilityErrorBoundary2,
    {
      fallback: () => null,
      errorContext: getObservabilityContext5({
        tags: {
          errorName: `Masonry - Error while rendering widget: ${widget.id}`,
          container: appId,
          widgetId: widget.id
        }
      }),
      onError: (err) => {
        logError(
          `Masonry - Error while rendering widget: ${widget.id} ${err.message}`
        );
      }
    },
    widget.module !== "default" && widget.custom_type ? /* @__PURE__ */ React14.createElement(CustomWidget, { widget }) : /* @__PURE__ */ React14.createElement(MasonrySupportedWidget2, { widget })
  )
);

// src/components/widgets-wrapper/widgets-wrapper.component.tsx
var WidgetsWrapper = () => {
  const { appId, apiVersion, apiParams } = useGetConfig();
  const { data, isLoading, error } = useGetWidgetContainer(
    appId,
    apiVersion,
    apiParams
  );
  const { widgets } = data || {};
  if (error) {
    return /* @__PURE__ */ React15.createElement(ErrorPage, { errorType: ERROR_TYPES.API_ERROR });
  }
  if (isLoading) {
    return /* @__PURE__ */ React15.createElement(MasonrySpinner, null);
  }
  if (apiVersion < 2)
    return /* @__PURE__ */ React15.createElement(StackLayout2, { spacing: "$two", horizontalAlignment: "stretch" }, widgets == null ? void 0 : widgets.map(
      (widget) => /* @__PURE__ */ React15.createElement(WidgetWrapper, { widget, key: widget == null ? void 0 : widget.id, appId })
    ));
  return /* @__PURE__ */ React15.createElement(StackLayout2, { spacing: "$two", horizontalAlignment: "stretch" }, widgets == null ? void 0 : widgets.map(
    (widget) => /* @__PURE__ */ React15.createElement(WidgetWrapperV2, { widget, key: widget == null ? void 0 : widget.id, appId })
  ));
};

// src/components/masonry-provider/masonry-provider.component.tsx
var MasonryProvider = ({
  config
}) => {
  const [masonryConfig] = useState2(config);
  return /* @__PURE__ */ React16.createElement(
    ObservabilityErrorBoundary3,
    {
      fallback: () => null,
      errorContext: getObservabilityContext6({
        tags: {
          errorName: `Masonry - Error while rendering Masonry Container: ${config == null ? void 0 : config.appId}`,
          container: config == null ? void 0 : config.appId
        }
      }),
      onError: (err) => {
        logError(
          `Masonry - Error while rendering Masonry Container: ${err.message}`
        );
      }
    },
    /* @__PURE__ */ React16.createElement(MasonryConfigContext.Provider, { value: masonryConfig }, /* @__PURE__ */ React16.createElement(WidgetsWrapper, null))
  );
};

// src/utils/validate-config.ts
import { merge } from "lodash";

// src/utils/masonry-config-schema.ts
import {
  object,
  optional,
  number,
  string,
  array,
  func,
  union,
  record,
  boolean
} from "superstruct";
var CommonRecordValuesApiParams = union([string(), number(), boolean()]);
var ApiParamsSchema = record(string(), CommonRecordValuesApiParams);
var MasonryConfigSchema = object({
  appId: string(),
  apiVersion: number(),
  apiParams: optional(
    record(
      string(),
      union([
        CommonRecordValuesApiParams,
        array(CommonRecordValuesApiParams),
        ApiParamsSchema
      ])
    )
  ),
  customWidgetModules: optional(
    array(
      object({
        moduleKey: string(),
        customWidgetDataHooks: optional(
          object({
            useTextWithCTACardWidgetData: optional(func()),
            useLargeVisualCardWidgetData: optional(func()),
            useSmallVisualCardWidgetData: optional(func()),
            useCarouselWidgetData: optional(func()),
            useXSVisualCardWidgetData: optional(func()),
            useWelcomeBannerWidgetData: optional(func()),
            // Deprecate - v2
            useHeroBannerWidgetData: optional(func()),
            useProductCarouselWidgetData: optional(func()),
            useProgressRingCardWidgetData: optional(func()),
            useProgressBarCardWidgetData: optional(func()),
            useTwoUpCardWidgetData: optional(func()),
            useGenericCarouselWidgetData: optional(func()),
            useStackWidgetData: optional(func()),
            useImageFooterWidgetData: optional(func())
          })
        ),
        customWidgetsUI: optional(
          array(
            object({
              type: string(),
              widget: func()
            })
          )
        )
      })
    )
  ),
  analytics: object({
    productArea: string(),
    screenName: string()
  }),
  uiConfig: optional(
    object({
      CustomLoader: optional(func()),
      spinnerConfig: optional(
        object({
          tint: optional(string()),
          size: optional(union([string(), number()])),
          thickness: optional(number()),
          containerHeight: optional(string())
        })
      )
    })
  )
});

// src/utils/validate-config-with-schema.ts
import { validate } from "superstruct";
function validateConfigWithSchema(config, schema) {
  const messageSuffix = " is required when initializing Masonry";
  const [err] = validate(config, schema);
  if (!err) {
    return [];
  }
  return err.failures().map((failure) => failure.key + messageSuffix);
}

// src/utils/validate-config.ts
var formatConfigWithDefaultValues = (config) => merge({}, defaultConfig, config);
function validateAndFormatConfig(config) {
  if (!config)
    throw new Error(
      "Please provide a configuration object to initialize Masonry"
    );
  const errors = validateConfigWithSchema(config, MasonryConfigSchema);
  if (errors == null ? void 0 : errors.length)
    throw new Error(`
${errors.join("\n")}`);
  if (config.apiVersion < MINIMUM_API_VERSION || config.apiVersion > MAXIMUM_API_VERSION) {
    throw new Error(
      `
The apiVersion provided is not supported by masonry module. Please provide a version between ${MINIMUM_API_VERSION} & ${MAXIMUM_API_VERSION} `
    );
  }
  const formattedConfig = formatConfigWithDefaultValues(config);
  return formattedConfig;
}

// src/utils/init-masonry.tsx
var Masonry = class {
  constructor(clientConfig) {
    this.Provider = () => /* @__PURE__ */ React17.createElement(MasonryProvider, { config: this.config });
    this.checkConfigForNullOrUndefined(clientConfig);
    this.config = validateAndFormatConfig(clientConfig);
  }
  checkConfigForNullOrUndefined(config) {
    if (!config && !this.config) {
      throw new Error(
        "No config provided for Masonry Module. Please use Masonry.init() to initialize Masonry."
      );
    }
  }
  getConfig() {
    this.checkConfigForNullOrUndefined();
    return this.config;
  }
  validateConfig() {
    this.checkConfigForNullOrUndefined();
    validateAndFormatConfig(this.config);
  }
  setConfig(clientConfig) {
    this.checkConfigForNullOrUndefined();
    this.config = validateAndFormatConfig(clientConfig);
  }
};
var initMasonry = (config) => new Masonry(config);

// src/components/masonry-pdf/masonry-pdf.component.tsx
import { useEffect, useState as useState3 } from "react";
import { getInitializationConfig } from "@leagueplatform/core";
import { useGeneratePDFReport } from "@leagueplatform/masonry-api";
import { useParams, useQueryParams } from "@leagueplatform/routing";
var MasonryPDF = ({
  loader: LoadingComponent
}) => {
  const [generatePDF, setGeneratePDF] = useState3(false);
  const params = useParams();
  const query = useQueryParams();
  const filename = query.get("filename");
  const templateId = query.get("templateId");
  useEffect(() => {
    if (params.containerType && params.version)
      setGeneratePDF(true);
  }, [params]);
  console.log("params, query params", params, filename, templateId);
  const { isError, data, isLoading } = useGeneratePDFReport(generatePDF, __spreadValues({
    containerId: params.containerType,
    filename: filename || `${params.containerType}_${params.version}_report`,
    version: +params.version
  }, templateId && { templateId }));
  console.log("Error and Data from get PDF container", isError, data);
  useEffect(() => {
    if (data)
      getInitializationConfig().customMethods.handleLink(data, "_self");
  }, [data]);
  if (isLoading)
    return LoadingComponent;
  return null;
};

// src/constants/masonry-routes.ts
var MASONRY_ROUTES = {
  PDF_GENERATION: "/masonry/pdf/:version/:containerType"
};

// src/index.ts
var src_default = { init: initMasonry };
export {
  MASONRY_ROUTES,
  MasonryPDF,
  src_default as default
};
//# sourceMappingURL=index.js.map